var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "m15.835 15.835-2.92-2.92m2.09-5c0 3.91-3.18 7.09-7.09 7.09s-7.08-3.18-7.08-7.09a7.08 7.08 0 0 1 7.08-7.08c3.91 0 7.09 3.17 7.09 7.08"
  })));
};
export { SvgSearchIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/SearchIcon.06a899e2.svg";